export default "72efac1fd842b0017c7fd57f5278a18a.png";